import React from "react";
import WatermarkLeftPanelOverlay from "./WatermarkLeftPanelOverlay";
import WatermarkColorPickerBody from "./WatermarkColorPickerBody";
import WatermarkPositionOverlayContent from "./WatermarkPositionOverlayContent";
import { useWatermarkToolbarOverlay } from "./WatermarkToolbarOverlayContext";
import { WATERMARK_CONTENT_TYPES } from "./watermarkSettings";

const WatermarkLeftPanelOverlays = ({
  settings,
  onChange,
  disabled = false,
  positionStageSelector = ".transform-preview__canvas",
}) => {
  const ctx = useWatermarkToolbarOverlay();
  if (!ctx || !settings) return null;

  const { leftPanelSelector, closeOverlay, isColorOpen, isPositionOpen } = ctx;
  const isLogo =
    settings?.contentType === WATERMARK_CONTENT_TYPES.LOGO &&
    Boolean(settings?.logoUrl);

  const patch = (partial) => onChange({ ...settings, ...partial });

  const colorValue = isLogo
    ? settings.logoTintColor || settings.color || "#FFFFFF"
    : settings.color || "#FFFFFF";

  const applyColor = (c) => {
    if (isLogo) patch({ logoTintColor: c });
    else patch({ color: c });
  };

  const removeLogoColor = () => {
    if (isLogo) patch({ logoTintColor: null });
  };

  return (
    <>
      <WatermarkLeftPanelOverlay
        open={isColorOpen}
        title="Color"
        panelSelector={leftPanelSelector}
        onClose={closeOverlay}
        showCloseButton={false}
        closeOnOutsideClick={false}
        ignoreCloseSelectors={[
          ".text-format-toolbar",
          ".image-format-toolbar",
          ".tft-color-btn",
          ".watermark-text-format-toolbar",
          ".editor-text-format-toolbar",
        ]}
      >
        <WatermarkColorPickerBody
          color={colorValue}
          onChange={applyColor}
          onClose={closeOverlay}
          showRemoveColor={isLogo}
          canRemoveColor={isLogo && Boolean(settings.logoTintColor)}
          onRemoveColor={removeLogoColor}
        />
      </WatermarkLeftPanelOverlay>

      <WatermarkLeftPanelOverlay
        open={isPositionOpen}
        title="Position"
        className="wlp-overlay--position"
        panelSelector={leftPanelSelector}
        onClose={closeOverlay}
        showCloseButton={false}
        closeOnOutsideClick={false}
        ignoreCloseSelectors={[
          ".text-format-toolbar",
          ".image-format-toolbar",
          ".tft-position-btn",
          ".tft-text-btn",
          ".watermark-text-format-toolbar",
          ".editor-text-format-toolbar",
        ]}
      >
        <WatermarkPositionOverlayContent
          settings={settings}
          onChange={onChange}
          onClose={closeOverlay}
          disabled={disabled}
          positionStageSelector={positionStageSelector}
        />
      </WatermarkLeftPanelOverlay>
    </>
  );
};

export default WatermarkLeftPanelOverlays;
